import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';


const useStyles = makeStyles(theme => createStyles({
    group: {
        height: '100%'
    },
    error: {
        backgroundColor: theme.palette.error.main
    },
    progress: {
        position: 'absolute',
        padding: '4px'
    },
    spacer: {
        visibility: 'hidden'
    },
    orange: {

    }
}));

export default function({
    children,
    suffix = null,
    group = false,
    loading,
    className,
    color,
    ...props
}) {
    const classes = useStyles();

    return (
        <>
        <Button
            {...props}
            color={color}
            className={clsx(className, {
                [classes.group]: group,
                [classes.error]: color === 'error',
                [classes.orange]: color === 'orange'
            })}
        >
            {children}
            {loading && (
                <CircularProgress className={classes.progress}/>
            )}
        </Button>
        {suffix}
        </>
    );
}